import { useEffect, useRef } from "react";

export type CheckboxSelectAllProps<T = string> = {
  itemsChecked: T[];
  maxLength: number;
  setChecked: () => void;
};

export const CheckboxSelectAll = <T,>({
  itemsChecked,
  maxLength,
  setChecked,
}: CheckboxSelectAllProps<T>) => {
  const cbRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!cbRef.current) {
      return;
    }

    if (itemsChecked.length === 0) {
      cbRef.current.checked = false;
      cbRef.current.indeterminate = false;
    } else if (itemsChecked.length === maxLength) {
      cbRef.current.checked = true;
      cbRef.current.indeterminate = false;
    } else {
      cbRef.current.checked = false;
      cbRef.current.indeterminate = true;
    }
  }, [itemsChecked, maxLength]);

  return <input type="checkbox" onChange={setChecked} ref={cbRef} />;
};
